import { render, staticRenderFns } from "./UploaderAvatar.vue?vue&type=template&id=dab63422&"
import script from "./UploaderAvatar.vue?vue&type=script&lang=js&"
export * from "./UploaderAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UploaderAvatar.vue?vue&type=style&index=0&id=dab63422&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports